module.exports = __webpack_public_path__ + "static/img/gx.7f6ab71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s33/gx.png
// module id = XxkV
// module chunks = 2